import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TCITooltip } from '@/components/ui/Tooltip';
import styles from './Pager.module.scss';

const buttonShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired
});

export const pagerDataShape = PropTypes.shape({
  next: buttonShape,
  position: PropTypes.number.isRequired,
  previous: buttonShape,
  total: PropTypes.number.isRequired
});

export default class Pager extends Component {
  static propTypes = {
    children: PropTypes.node,
    fullWidth: PropTypes.bool,
    modelName: PropTypes.string.isRequired,
    pagingData: pagerDataShape.isRequired,
    showPosition: PropTypes.bool,
  };

  static defaultProps = {
    children: null,
    fullWidth: false,
    showPosition: true,
  };

  static _buttonTooltip(tooltipLabel) {
    const maxCharacters = 38;
    const truncatedLabel = `${tooltipLabel.substring(0, maxCharacters)}...`;

    // .replace(/<[^>]*>?/gm, '') to strip html tags when calculating length
    return tooltipLabel.replace(/<[^>]*>?/gm, '').length < maxCharacters ? tooltipLabel : truncatedLabel;
  }

  _renderButton(buttonData, type) {
    const buttonContent = <i className={`fa fa-arrow-${type === 'previous' ? 'left' : 'right'}`} />;
    const pagingButtonClass = this.props.children ? `${styles.smallPagingButton}` : `${styles.pagingButton}`;

    if (!buttonData) {
      return (
        <span aria-disabled aria-label={`${type}`} className={pagingButtonClass}>
          {buttonContent}
        </span>
      );
    }

    return (
      <TCITooltip side="bottom">
        <TCITooltip.Trigger asChild>
          <a
            aria-label={`${type} ${this.props.modelName}`}
            className={pagingButtonClass}
            href={buttonData.url}
          >
            {buttonContent}
          </a>
        </TCITooltip.Trigger>
        <TCITooltip.Content>{Pager._buttonTooltip(buttonData.label)}</TCITooltip.Content>
      </TCITooltip>
    );
  }

  _renderPosition() {
    const label = this.props.showPosition ? `${this.props.pagingData.position} of ${this.props.pagingData.total}` : '';

    return (
      <span className={styles.positionContainer}>
        {label}
      </span>
    );
  }

  render() {
    return (
      <div className={styles.pagingContainer}>
        {this._renderButton(this.props.pagingData.previous, 'previous')}
        {this.props.children || this._renderPosition()}
        {this._renderButton(this.props.pagingData.next, 'next')}
      </div>
    );
  }
}
